import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import { Row, Col, Table, Card, CardBody, CardHeader, Button} from "reactstrap";
import Proptypes from "prop-types";
import ReactJson from 'react-json-view';
import {getStagingConfigs} from "../../../actions/actionStaging"
import iconYes from "../../../../assets/images/icon_yes.svg";
import iconNo from "../../../../assets/images/icon_no.svg";


class ViewStagingConfig extends Component{
    constructor(props){
        super(props);
         this.state = {
            currentStagingConfig: {}
        }
    }
  
    componentDidMount(){
        this.props.getStagingConfigs();
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.staging_configs.length > 0){
            let currentStagingConfig = nextProps.staging_configs.find(staging_configs => staging_configs.staging_config_id === this.props.match.params.id);
            this.setState({currentStagingConfig: currentStagingConfig});
        }
    }

    render(){
        const {currentStagingConfig} = this.state;
        return (
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <strong>View Staging Config</strong></div>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                    <div className="profile-table">
                                            {currentStagingConfig ?
                                                <Table >
                                                    <tbody>
                                                        <tr><td><h4>Id</h4></td><td>{currentStagingConfig.staging_config_id ? currentStagingConfig.staging_config_id : "-"}</td></tr>
                                                        <tr><td><h4>Zone</h4></td><td>{currentStagingConfig.zone_name ? currentStagingConfig.zone_name : "-"}</td></tr>
                                                        <tr><td><h4>Image</h4></td><td>{currentStagingConfig.image_friendly_name ? currentStagingConfig.image_friendly_name : "-"}</td></tr>
                                                        <tr><td><h4>Desired Sessions</h4></td><td>{currentStagingConfig.num_sessions ? currentStagingConfig.num_sessions : "-"}</td></tr>
                                                        <tr><td><h4>Current Sessions</h4></td><td>{currentStagingConfig.num_current_sessions ? currentStagingConfig.num_current_sessions : "-"}</td></tr>
                                                        <tr><td><h4>Expiration (Hours)</h4></td><td>{currentStagingConfig.expiration ? currentStagingConfig.expiration : "-"}</td></tr>
                                                        <tr><td><h4>Allow Audio </h4></td><td><img src={currentStagingConfig.allow_kasm_audio ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Allow Clipboard Down </h4></td><td><img src={currentStagingConfig.allow_kasm_clipboard_down ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Allow Clipboard Up </h4></td><td><img src={currentStagingConfig.allow_kasm_clipboard_up ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Allow Downloads </h4></td><td><img src={currentStagingConfig.allow_kasm_downloads ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Allow Microphone </h4></td><td><img src={currentStagingConfig.allow_kasm_microphone ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Allow Uploads </h4></td><td><img src={currentStagingConfig.allow_kasm_uploads ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>   
                    </Col>
                </Row>
            </div>
        );}
}

ViewStagingConfig.propTypes = {
    staging_configs: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        staging_configs: state.staging.staging_configs || [],
    }),
dispatch => 
    ({  
        getStagingConfigs: () => dispatch(getStagingConfigs()),
    }))(ViewStagingConfig);


// WEBPACK FOOTER //
// ./src/views/Staging/ViewStagingConfig/ViewStagingConfig.js